var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Entity, EntityBuilder, Type } from '@decahedron/entity';
import { Question } from './question/Question';
import { MultiChoiceQuestion } from './question/MultiChoiceQuestion';
import { Result } from './Result';
import { Welcome } from '../Welcome';
var FormTemplate = /** @class */ (function (_super) {
    __extends(FormTemplate, _super);
    function FormTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.uuid = null;
        _this.formUuid = '';
        _this.languageId = 1;
        _this.companyId = null;
        _this.jobId = null;
        _this.name = '';
        _this.lang = 'en-GB';
        _this.createdBy = 0;
        _this.createdAt = '';
        _this.updatedAt = '';
        _this.archivedAt = '';
        _this.lastUsedAt = '';
        _this.version = 1;
        _this.welcome = null;
        _this.questions = [];
        _this.results = [];
        return _this;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FormTemplate.prototype.fromJson = function (jsonData) {
        _super.prototype.fromJson.call(this, jsonData);
        if (jsonData.questions && jsonData.questions.length) {
            this.questions = jsonData.questions.map(function (question) { return ((question.options)
                ? EntityBuilder.buildOne(MultiChoiceQuestion, question)
                : EntityBuilder.buildOne(Question, question)); });
        }
        return this;
    };
    FormTemplate.prototype.ensureV1ResultScreens = function (i18n) {
        if (this.results.length) {
            return;
        }
        var resultScreens = [];
        var identifierMap = {
            1: 'A',
            3: 'B',
            4: 'C',
        };
        for (var i in identifierMap) {
            resultScreens.push({
                title: i18n.t("ats.job.application_form.results." + i + ".title", this.lang),
                description: i18n.t("ats.job.application_form.results." + i + ".description", this.lang),
                identifier: identifierMap[i],
            });
        }
        this.results = (EntityBuilder.buildMany(Result, resultScreens)).reverse();
    };
    var _a;
    __decorate([
        Type(Welcome),
        __metadata("design:type", typeof (_a = typeof Welcome !== "undefined" && Welcome) === "function" ? _a : Object)
    ], FormTemplate.prototype, "welcome", void 0);
    __decorate([
        Type(Result),
        __metadata("design:type", Array)
    ], FormTemplate.prototype, "results", void 0);
    return FormTemplate;
}(Entity));
export { FormTemplate };
